import DAImage from "../../../../src/assets/images/dataanalytics1.png";
import * as React from 'react';
export default {
  DAImage,
  React
};